import { render } from "./OrderPurchaseOrder.vue?vue&type=template&id=6b0ce236&scoped=true"
import script from "./OrderPurchaseOrder.vue?vue&type=script&lang=js"
export * from "./OrderPurchaseOrder.vue?vue&type=script&lang=js"

import "./OrderPurchaseOrder.vue?vue&type=style&index=0&id=6b0ce236&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0ce236"]])

export default __exports__